<template>
  <div class="new-content news-list2">
    <ul class="list" v-if="!_.isEmpty(dataSet)">
      <li v-for="(item, index) in dataSet" :key="`news-list-${index}`">
       
        <div class="content" style="font-size: 16px;">
          <p @click="$router.push({path: '/down?id=' + item.id + '&name=' + item.name})" style="cursor: pointer;">
      
            <span style="display: flex;
            align-items: center;"><img style="width: 60px;display:inline-block;margin-right:10px;height:60px" :src="item.icon"/> {{item.name }}</span>
            <b class="date">
              {{item.ftaTime }}
    
              </b>
          </p>
        
          <!-- <LineClamp class="desc" :msg="item.content | removeTag(' ')" :line="2" :isHtml="true" v-once></LineClamp> -->
        </div>
      </li>
    </ul>
   
  </div>
</template>

<script>
import LineClamp from '@/components/common/LineClamp'
import Loader from '../layout/Loader'

export default {
  name: 'NewsListContent',
  components: { LineClamp, Loader },
  props: {
    dataSet: {
      type: Array,
      default: () => { return [] },
      required: false
    },
    pageSize: {
      type: Number
    },
    isShowLoader: {
      type: Boolean
    }
  },
  data () {
    return {
      currentPage: 1
    }
  },
  methods: {
    goPager (page) {
      this.$parent.getData(page)
    },
    getclass(name){
      if(name=='RCEP协定文本'){
        return 'bgcolor1'
      }
      else if(name=='RCEP政策解读'){
        return 'bgcolor2'
      }
      else if(name=='培训资料'){
        return 'bgcolor3'
      }
      else if(name=='其他'){
        return 'bgcolor4'
      }
      else{
        return '' 
      }
      

    },
  }
}
</script>
<style scoped>
.bgcolor1{
  background-image: -moz-linear-gradient( 0deg, rgb(161,109,252) 0%, rgb(218,168,253) 99%);
  background-image: -webkit-linear-gradient( 0deg, rgb(161,109,252) 0%, rgb(218,168,253) 99%);
  background-image: -ms-linear-gradient( 0deg, rgb(161,109,252) 0%, rgb(218,168,253) 99%);
  box-shadow: 0px 8px 27px 0px rgba(177, 125, 252, 0.4);
}
.bgcolor2{
  background-image: -moz-linear-gradient( 0deg, rgb(64,160,247) 0%, rgb(106,207,238) 100%);
background-image: -webkit-linear-gradient( 0deg, rgb(64,160,247) 0%, rgb(106,207,238) 100%);
background-image: -ms-linear-gradient( 0deg, rgb(64,160,247) 0%, rgb(106,207,238) 100%);
box-shadow: 0px 8px 27px 0px rgba(71, 168, 246, 0.4);
}
.bgcolor3{
  background-image: -moz-linear-gradient( 0deg, rgb(255,92,156) 0%, rgb(255,166,106) 100%);
  background-image: -webkit-linear-gradient( 0deg, rgb(255,92,156) 0%, rgb(255,166,106) 100%);
  background-image: -ms-linear-gradient( 0deg, rgb(255,92,156) 0%, rgb(255,166,106) 100%);
  box-shadow: 0px 8px 27px 0px rgba(255, 100, 150, 0.4);
 
  
}
.bgcolor4{
  background-image: -moz-linear-gradient( 0deg, rgb(232,112,230) 0%, rgb(218,176,252) 100%);
    background-image: -webkit-linear-gradient( 0deg, rgb(232,112,230) 0%, rgb(218,176,252) 100%);
    background-image: -ms-linear-gradient( 0deg, rgb(232,112,230) 0%, rgb(218,176,252) 100%);
    box-shadow: 0px 8px 27px 0px rgba(228, 128, 236, 0.4);
}
  .new-content >>> .ivu-page{
    text-align: center;
    padding: 50px 0 15px;
  }
  .new-content >>> .ivu-page a{
    font-size: 16px;
  }
  .new-content >>> .ivu-page-total,
  .new-content >>> .ivu-page-options-elevator,
  .new-content >>> .ivu-page-options-elevator input{
    font-size: 15px;
    color: #777;
  }
  .new-content >>> .ivu-page-item-active{
    background-color: #0470e3;
    border-color: #0470e3;
  }
  .list li{
    position: relative;
    padding-right: 5px;
    padding-bottom: 5px;
    padding-top: 5px;
    border-bottom: 0.5px solid #E9E9E9;
  }
  .list li.plaintext{
    padding-top: 18px;
    padding-bottom: 0px;
  }
  .list li:first-child{
    padding-top: 0;
  }
  .list li:first-child .cover{
    top: 0;
    display: block;
    transform: translateY(0);
  }
  .list li:last-child{
    padding-bottom: 10px;
    border-bottom: 0;
  }
  .list li .cover{
    width: 210px;
    position: absolute;
    top: 25px;
    left: 0;
    top:50%;
    transform: translateY(-50%);
  }
  .list li .cover:hover{
    text-decoration: none;
    box-shadow: none;
  }
  .list li .cover:after{
    width:0;
    height:0;
  }
  .list li .cover img{
    width: 100%;
    height: auto;
  }
  .list li .content{
    padding-top: 5px;
   
  }
  .list li.plaintext{
    padding-left: 0;
  }
  .list li.plaintext .content{
    min-height: 0;
    padding-top: 0;
  }
  .list li .content .title span:hover{
    color: #0470e3;
  }
  .list li .title{
    margin-bottom: 10px;
    padding-right: 160px;
    position: relative;
  }
  .list li .title.hotes{
    position: relative;
    /*padding-left: 32px;*/
  }
  .list li .title .hot{
    border: 0.5px solid #2681FF;
    border-radius: 2px;
    color: #1F8AFD;
    /*font-size: 8px;*/
    font-size: 10px;
    padding: 0 3px;
    /*position: absolute;*/
    /*left: 0;*/
    /*top: 50%;*/
    /*transform: translateY(-50%);*/
    position: relative;
    top: -1px;
  }
  .list li .title.hotes a{
    padding-left: 5px;
  }
  .list li .title span{
    color: #333;
    font-size: 1.6rem;
    line-height: 24px;
  }
  /* .list li .title a:hover{
    color: #0470e3;
  } */
  .list li .date{
    color: #999;
    font-size: 16px;
    font-weight: normal;
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    right: 0;
  }
  .list li .desc{
    font-size: 1.5rem;
    line-height: 24px;
    color: #666;
  }
  .nodata{
    text-align: center;
    padding-top: 30px;
    font-size: 16px;
    font-style: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/ftaList/ListContent.vue